var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cart-container',{attrs:{"title":`${_vm.$t('createOrder.yourOrder')}`,"price":_vm.fullPrice}},_vm._l((_vm.cartProducts),function(product){return _c('cart-product',{key:product.id,class:_vm.$style.product,attrs:{"product":product}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }